import { placeholderImage } from "@grandvisionhq/utils";
const createImageUrl = (imagePath, options) => {
  const imageQueryParams = options?.imageQueryParams || "";
  const validImagePath = imagePath?.startsWith("http");
  if (validImagePath) {
    return `${imagePath}${imageQueryParams}`;
  }
  return `${placeholderImage.url}${imageQueryParams}`;
};
export {
  createImageUrl
};
//# sourceMappingURL=create-image-url.js.map
